import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="inline-block text-xs font-medium text-secondary-500 uppercase tracking-widest mb-4 border border-secondary-200/60 rounded-full px-3 py-1">
              Kakobuy Sheet
            </span>
            <div className="hidden lg:block mt-20">
              <div className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs text-foreground-400 uppercase tracking-wider">
                  10 {t('about.users')}
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-8 leading-tight">
              {t('about.h2')}
            </h2>
            <div className="space-y-5">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-light">
                {t('about.p1')}
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-light">
                {t('about.p2')}
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-light">
                {t('about.p3')}
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mt-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                {t('badge.updated')}
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                {t('badge.verified')}
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                {t('badge.safe')}
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                {t('badge.polish')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}